import { getMonthName } from '@helpers/chartHelpers';
import I18n from '@src/i18n';
import React from 'react';
import { Doughnut, Line } from 'react-chartjs-2';

const getStepSize = (props: any) => {
  let biggestData = 0
  for(let data of props.data){
    data > biggestData ? biggestData = data : ''
  }
  const maxValue = biggestData > props.maxRange ? biggestData : props.maxRange
  const stepFunction = (parseInt(maxValue)) / 10;

  return stepFunction.toFixed(0)
}
const returnRange = (props: any) => {
  
    const getStableLines = (number: any) => {
      const resultArray = []
      if(props.data.length === 1){
        for(let i = 0; i < 2 ; i++){
          resultArray.push(number)
        }
      } else {
        for(let i = 0; i < props.data.length ; i++){
          resultArray.push(number)
        }
      }
      return resultArray;
    }

    const calculatedStepSize = getStepSize(props)
    const options = {
      maintainAspectRaio: true,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          ticks: {
            scaleOverride: true,
            stepSize: calculatedStepSize
          }
        }]
      }
    };
      
    const data = {
      labels: props.labels,
      datasets: [
        {
          label: I18n.l("dashboard.dones"),
          fill: false,
          lineTension: 0,
          borderColor: 'rgba(75,192,192,0.5)',
          pointRadius: 5,
          pointBackgroundColor: 'rgba(75,192,192,1)',
          data: props.data
        },
        {
          label: 'min-range',
          fill: 'origin',
          borderColor: 'rgba(250,218,94,0.8)',
          backgroundColor: 'rgba(250,218,94,0.8)',
          pointRadius: 0.1,
          data: getStableLines(props.minRange)
        },
        {
          label: 'max-range',
          fill: 'end',
          borderColor: 'rgba(250,218,94,0.8)',
          backgroundColor: 'rgba(250,218,94,0.8)',
          pointRadius: 0.1,
          data: getStableLines(props.maxRange)
        }
      ]
    }
  
    return ( <Line data={data} width={750} height={375} options={options}/> )
  }
  
  const returnDoughnutChart = (props: any) => {
    const options = {
      maintainAspectRaio: true,
      legend: {
        display: false,
      }
    };
    
    const getPercentage = ()  => {
      let outside = 0;
      let resultArray = []
      for(let data of props.data){
        if(data > props.maxRange || data < props.minRange){
          outside += 1
        }
      }
      resultArray.push(outside, (props.data.length - outside))
      return resultArray
    }
    
    const doughnutPercentage = getPercentage()
    const percentage = (doughnutPercentage[0]/(doughnutPercentage[0] + doughnutPercentage[1])) * 100
  
    const data = {
      labels: [I18n.l('common.out.of.range'),I18n.l("common.ok")],
      datasets: [
        {
          label: 'teste',
          data: doughnutPercentage,
          backgroundColor: ['rgb(255, 205, 86)', 'rgb(181,181,181)']
        },
      ]
    }
    return (
      <div className="donut-generator-container">
        <div className="donut-size">
          <Doughnut data={data} height={300} width={300} options={options}/>
        </div>
        <div className="translated-text">
          <p className="percentage-text">{`${percentage.toFixed(1)}%`}</p>
          <p className="info-text">{I18n.l('common.out.of.range')}</p>
        </div>
      </div>
    )
  }

  const getPeriodArray = (receivedValue: any, period: any) => {
      const periodArray = []
      if(period === 'year'){
        for(let singleData of receivedValue){
          let executedAt = new Date(singleData.executedAt).getMonth()
          if(periodArray.indexOf(executedAt) === -1 && singleData.values[0]){
            periodArray.push(executedAt)
          }
        }
      }

      else {
        const verificationArray: any[] = [];
        for(let singleData of receivedValue) {
          let executedAt = new Date(singleData.executedAt)
          const checkFullTime = `${executedAt.getDate()}/${executedAt.getMonth()}`
          if(verificationArray.indexOf(checkFullTime) === -1 && singleData.values[0]) {
            periodArray.push(singleData.executedAt)
            verificationArray.push(checkFullTime)
          }
        }
      }
    
      return periodArray.sort()
  }

  const generateMonthDataArray = (dateArray: any, data: any, periodType: any) => {
    const valueArray: any[] = [];
    if(typeof(data[0].values[0]) === 'string'){
      if(periodType === 'year'){
    
        for(let month of dateArray){
          const monthArray = []
          for(let singleData of data){
            const date = new Date(singleData.executedAt).getMonth();
            if(month === date && singleData.values[0]){
              monthArray.push(singleData.values[0])
            }
          }
          valueArray.push(monthArray.length)
        }
        
        } else {
          for(let day of dateArray){
            const dayArray = []
            for(let singleData of data){
              const executedDate = new Date(singleData.executedAt).getDate();
              const evalDate = new Date(day).getDate()
              if(evalDate === executedDate && singleData.values[0]){
                dayArray.push(singleData.values[0])
              }
            }
            valueArray.push(dayArray.length)
          }
        }
    } else {
      if(periodType === 'year'){
        for(let month of dateArray){
          const monthArray: any[] = []
          for(let singleData of data){
            const date = new Date(singleData.executedAt).getMonth();
            if(month === date && singleData.values[0]){
              monthArray.push(singleData.values[0])
            }
          }
          let sumValue = ''
          if(monthArray.length > 0){
            sumValue = (monthArray.reduce((total, num) => total + num ) / monthArray.length)
          }
          valueArray.push(sumValue)

        }
        
        } else {
          for(let day of dateArray){
            const dayArray: any = []
            for(let singleData of data){
              const executedDate = new Date(singleData.executedAt).getDate();
              const evalDate = new Date(day).getDate()
              if(evalDate === executedDate && singleData.values[0]){
                dayArray.push(singleData.values[0])
              }
            }
            let sumValue = ''
            if(dayArray.length > 0){
            sumValue = (dayArray.reduce((total, num) => total + num ) / dayArray.length)

          }
            valueArray.push(sumValue)
          }
        }
    }
    return valueArray
  }

  const generateData = (props: any) => {
    
    let monthArray = getPeriodArray(props.stateData, props.period)
    let valueArray = generateMonthDataArray(monthArray, props.stateData, props.period)

    if(props.period === 'year'){
      for(let i = 0; i < monthArray.length; i++){
        monthArray[i] = getMonthName(monthArray[i])
      }
    }

    if(props.period === 'month'){
      for(let i = 0; i < monthArray.length;i++){
        const currentTimeStamp = new Date(monthArray[i])
        monthArray[i] = `${currentTimeStamp.getDate()}/${currentTimeStamp.getMonth()}`
      }
    }
    
    const resultObject = {
      data: valueArray,
      maxRange: props.maxRange,
      minRange: props.minRange,
      title: props.title,
      labels: monthArray
    }

    return resultObject;
  }
  
  const returnRangeCombo = (props: any) => {
    const data = generateData(props);
    return(
      <div>
          {returnRange(data)}
        <div className="doughnut-container">
          {returnDoughnutChart(data)}
        </div>
      </div>
    )
  }


export default returnRangeCombo